import { ClubReviewsSearch } from '@features/search/components/artist-card/ClubReviewSearch.tsx';
import { createFileRoute } from '@tanstack/react-router';

import { redirectUnauthenticated } from '@/shared/helper/redirectUnauthenticated';

export const Route = createFileRoute(
  '/artist/$id/profile-info/$clubId/reviews'
)({
  beforeLoad: ({ context }) => {
    redirectUnauthenticated(context);
  },
  component: ClubReviewsSearch
});
